/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const HistoryIcon = /*#__PURE__*/ createSvgIcon(
  'HistoryIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M10 17c-1.833 0-3.406-.608-4.719-1.823-1.312-1.215-2.059-2.712-2.24-4.49a.524.524 0 01.178-.49.762.762 0 01.53-.197c.195 0 .37.056.522.167a.658.658 0 01.27.458c.153 1.375.747 2.531 1.782 3.469C7.358 15.03 8.583 15.5 10 15.5c1.514 0 2.809-.538 3.885-1.615C14.962 12.81 15.5 11.514 15.5 10c0-1.514-.538-2.809-1.615-3.885C12.81 5.038 11.514 4.5 10 4.5c-.861 0-1.657.178-2.386.533A5.311 5.311 0 005.77 6.5H7.25c.213 0 .39.071.534.214A.72.72 0 018 7.246c0 .21-.072.39-.216.535A.72.72 0 017.25 8h-3.5a.726.726 0 01-.534-.216A.726.726 0 013 7.25v-3.5c0-.213.071-.39.214-.534A.72.72 0 013.746 3c.21 0 .39.072.535.216a.72.72 0 01.219.534v1.958A6.948 6.948 0 016.885 3.73 6.745 6.745 0 0110 3c.972 0 1.883.185 2.732.554.849.37 1.588.869 2.216 1.497a7.11 7.11 0 011.498 2.217c.37.85.554 1.76.554 2.732 0 .972-.185 1.883-.554 2.732a7.111 7.111 0 01-1.498 2.216 7.111 7.111 0 01-2.216 1.498c-.85.37-1.76.554-2.732.554zm.75-7.625l1.875 1.875a.681.681 0 01.219.52.759.759 0 01-.24.522.73.73 0 01-1.062 0l-2.057-2.057a.833.833 0 01-.172-.25.696.696 0 01-.063-.287V6.743a.71.71 0 01.219-.53A.732.732 0 0110 6c.208 0 .385.072.531.216a.72.72 0 01.219.534v2.625z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default HistoryIcon;
